import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A7182
 *
 * @param {SvgIconProps} props - svg props
 */
export const RemoveButtonIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M7.00008 11C6.81599 11 6.66675 11.1492 6.66675 11.3333V12.6667C6.66675 12.8508 6.81599 13 7.00008 13C12.4369 13 11.0358 13 17.0001 13C17.1842 13 17.3334 12.8508 17.3334 12.6667V11.3333C17.3334 11.1492 17.1842 11 17.0001 11C11.5623 11 12.9605 11 7.00008 11Z' fill='white'/>
        </SvgIcon>
    )
}

export default RemoveButtonIcon
